import gql from 'graphql-tag'
import {
	category as categoryFragment,
	surcharge as surchargeFragment,
	options as optionsFragment
} from './fragments'


export default gql`
query getCategory($id: ID!) {
	cashAssist {
		getCategory(id: $id) {
			id
			mod_ver
			cashRegisterId
			concepts
			...categorymain
			...categorySurcharge
			...categoryOptions
		}
	}
}
${categoryFragment}
${surchargeFragment}
${optionsFragment}`

